exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.socialList__img[data-v-365357f5] {\n    display: block;\n    width: auto;\n    height: auto;\n    max-width: 24px;\n    max-height: 24px;\n    -o-object-fit: contain;\n       object-fit: contain;\n    -webkit-transition: opacity 0.3s ease 0s;\n    transition: opacity 0.3s ease 0s;\n}\n.socialList--little-black-book .socialList__img[data-v-365357f5] {\n    width: 44px;\n    height: 28px;\n    max-width: none;\n    max-height: none;\n}\n.socialList__link:hover .socialList__img[data-v-365357f5] {\n    opacity: 0.72;\n}\n", ""]);

// exports
